// extracted by mini-css-extract-plugin
module.exports = {"speeds":"MonsterCombatInfo_speeds__2kS9g"};